export default "__VITE_ASSET__DYWo6n7p__"